import { UserSettingsModel } from "src/app/v2/pages/contracts/models/user-settings.model";
import { MockScenario } from "../mock-scenario";

/**
 * hasIps is derived from the IPS contract fixture being selected, so the IPS promo card on Avtaler
 * cannot contradict the contract list. hasPublicPension is hardcoded false because there is no
 * public-pension contract fixture to derive it from.
 */
export const generateMockUserSettings = (scenario: MockScenario): UserSettingsModel => {
  return {
    hasIps: scenario.contracts.includes("ips-1"),
    hasPublicPension: false,
  };
};
